<template>
  <div class="eft-payment-details">
    <!-- Payment Reference Banner -->
    <InfoBanner
      label="Payment Reference"
      :value="paymentReference"
      copyable
      :copy-value="paymentReference"
      success-message="Reference copied to clipboard"
      class="mb-4"
    />

    <!-- Bank Details -->
    <BankDetails :show-notice="true" />
  </div>
</template>

<script>
import BankDetails from '@/components/common/BankDetails.vue'
import { InfoBanner } from '@/components/ui'

export default {
  name: 'EftPaymentDetails',

  components: {
    BankDetails,
    InfoBanner
  },

  props: {
    paymentReference: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped>
.eft-payment-details {
  animation: fadeIn 0.3s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.mb-4 {
  margin-bottom: var(--space-4, 1rem);
}
</style>
